// src/components/BasicLayout.js
import React from 'react';
import Box from '@mui/material/Box';
import { Outlet } from 'react-router-dom'; // Verwende Outlet für das Layout

const BasicLayout = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #f5fff9, #fff)',
      }}
    >
      {/* Outlet für den Seiteninhalt */}
      <Outlet />
    </Box>
  );
};

export default BasicLayout;
